/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Optional metadata for favorite/save operations
 * @export
 * @interface FavoriteRequestBody
 */
export interface FavoriteRequestBody {
    /**
     * Set to true when favoriting a reposted item (used for notifications)
     * @type {boolean}
     * @memberof FavoriteRequestBody
     */
    isSaveOfRepost?: boolean;
}

/**
 * Check if a given object implements the FavoriteRequestBody interface.
 */
export function instanceOfFavoriteRequestBody(value: object): value is FavoriteRequestBody {
    let isInstance = true;

    return isInstance;
}

export function FavoriteRequestBodyFromJSON(json: any): FavoriteRequestBody {
    return FavoriteRequestBodyFromJSONTyped(json, false);
}

export function FavoriteRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): FavoriteRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isSaveOfRepost': !exists(json, 'is_save_of_repost') ? undefined : json['is_save_of_repost'],
    };
}

export function FavoriteRequestBodyToJSON(value?: FavoriteRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_save_of_repost': value.isSaveOfRepost,
    };
}

